<template>
  <div class="splash-page">
    <v-card class="card-spinner">
      <!-- header -->
      <div
        class="header navy darken-2 secondary--text pb-10 d-flex flex-column align-center"
      >
        <img class="logo" :src="firebase_host + '/static/img/logo_ombra.png'" />
      </div>
      <!-- content -->
      <div>
        <img class="spinner" :src="firebase_host + '/static/gif/lab.gif'" />

        <div
          class="dai-lab d-flex align-center justify-center flex-column mb-5 font-hemi-head"
        >
          <div class="d-flex align-center">
            Con
            <v-icon class="cuore ml-1 error--text">favorite</v-icon>
            dai laboratori di
          </div>
          <div>
            <a :href="host" target="_blank">fantapazz.com</a>
          </div>
        </div>
      </div>
    </v-card>

    <!-- <div class="palette-container">
        <transition name="spinner" mode="out-in">
          <img
            :key="0"
            class="paletta"
            v-if="spinner === 0"
            :src="spinners[0]"
          />

          <img
            :key="1"
            class="paletta"
            v-if="spinner === 1"
            :src="spinners[1]"
          />

          <img
            :key="2"
            class="paletta"
            v-if="spinner === 2"
            :src="spinners[2]"
          />
        </transition>
      </div> -->

    <!-- <v-progress-circular
      indeterminate
      class="primary--text darken-4"
    ></v-progress-circular> -->
    <!-- <lottie-animation
        :animationData="require('../../static/lottie/loading.json')"
        :autoPlay="true"
        :loop="true"
        class="spinner"
      /> -->
  </div>
</template>

<script>
import Config from "../../../config-app/config";
// import LottieAnimation from "lottie-web-vue";

export default {
  name: "splash",
  data() {
    return {
      host: Config.HOST,
      firebase_host: Config.FIREBASE_HOST,
      // interval: false,
      // spinners: [
      //   "/static/img/paletta-5.png",
      //   "/static/img/paletta-1.png",
      //   "/static/img/paletta-passo.png",
      // ],
    };
  },
  mounted() {
    console.log("--> Splash ready.");
  },
  destroyed() {
    console.log("<-- Splash destroyed.");
    // clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
@import "../../main.scss";
.splash-page {
  // background-color: var(--v-primary-base);
  // background-image: repeating-linear-gradient(-14deg, #4db6ac, #009688 530px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  padding-top: 25px;
  height: 100vh;

  .header {
    position: relative;
    overflow: hidden;

    &:after {
      content: "";
      position: absolute;
      bottom: -15px;
      left: 0;
      width: 115%;
      height: 35px;
      background-color: #f2f2f2;
      transform: skewY(-6deg);
    }
  }

  .card-spinner {
    width: 300px;
    background: #f2f2f2;
    .spinner {
      width: 115px;
      margin-top: 15px;
      margin-bottom: 15px;
    }
  }

  .dai-lab {
    font-size: 17px;
    .cuore {
      animation: pulse 1.25s infinite;
    }
  }
  .logo {
    width: 88px;
    margin: 15px;
  }

  // .palette-container {
  //   height: 100px;
  //   margin-top: 15px;
  //   .paletta {
  //     max-height: 50px;
  //   }
  //   .spinner-enter-active,
  //   .spinner-leave-active {
  //     transition: all 0.25s ease-out;
  //   }
  //   .spinner-enter-from {
  //     opacity: 0;
  //     transform: translateY(-30px);
  //   }
  //   .spinner-leave-to {
  //     opacity: 0;
  //     transform: translateY(-30px);
  //   }
  // }
}
</style>